/* eslint-disable eqeqeq */
/* eslint-disable camelcase */
/* eslint-disable no-param-reassign */
import React from 'react'
import { Typography as Text } from '@material-ui/core'
import { makeStyles, createStyles } from '@material-ui/styles'

// Get a list of buildings search criteria
export const getBuildingList = (city, buildings) => {
  let buildingsList
  if (city === 'OTHER') {
    buildingsList = buildings.filter(
      (building) =>
        building.city !== 'NEW BRUNSWICK' &&
        building.city !== 'PISCATAWAY' &&
        building.city !== 'NEWARK' &&
        building.city !== 'CAMDEN',
    )
  } else if (city === 'NEW BRUNSWICK') {
    buildingsList = buildings.filter(
      (building) =>
        building.city === 'NEW BRUNSWICK' || building.city === 'PISCATAWAY',
    )
  } else {
    buildingsList = buildings.filter((building) => building.city === city)
  }

  // Remove uncessesary data from list to increase performance
  const modifiedBuildingList = []

  buildingsList.forEach((building) => {
    modifiedBuildingList.push({
      address: building.address,
      bid: building.bid,
      name: building.name,
      city: building.city,
      lat: building.lat,
      lng: building.lng,
      departments: building.departments,
      picture: building.picture,
      zip: building.zip,
    })
  })

  return modifiedBuildingList
}

// Sort list alphabeticall to display
export const sortListAlphabetically = (list, key = 'name') => {
  const buildingsSortedAlphabetically = list.slice(0)
  buildingsSortedAlphabetically.sort((a, b) => {
    const x = a[key].toLowerCase()
    const y = b[key].toLowerCase()
    if (x < y) {
      return -1
    }
    if (x > y) {
      return 1
    }
    return 0
  })
  return buildingsSortedAlphabetically
}
export const sortListByCampusAndAlphabetically = (list) => {
  const newBrunswickStops = []
  const newarkStops = []
  const camdenStops = []

  list.forEach((stop) => {
    const { stop_lat, stop_lon } = stop

    if (
      stop_lat >= 39.942298899 &&
      stop_lat <= 39.953253 &&
      stop_lon >= -75.126481 &&
      stop_lon <= -75.119865832
    ) {
      camdenStops.push(stop)
    } else if (
      stop_lat >= 40.734819 &&
      stop_lat <= 40.746906 &&
      stop_lon >= -74.192475249 &&
      stop_lon <= -74.164721
    ) {
      newarkStops.push(stop)
    } else {
      newBrunswickStops.push(stop)
    }
  })

  newBrunswickStops.sort((a, b) => a.stop_name.localeCompare(b.stop_name))
  newarkStops.sort((a, b) => a.stop_name.localeCompare(b.stop_name))
  camdenStops.sort((a, b) => a.stop_name.localeCompare(b.stop_name))

  return [...newBrunswickStops, ...newarkStops, ...camdenStops]
}

export const sortParkingListAlphabetically = (list) => {
  const sortedParkingLots = list.slice(0)
  sortedParkingLots.sort((a, b) => {
    const x = a.propertyName?.toLowerCase() || ''
    const y = b.propertyName?.toLowerCase() || ''
    if (x < y) return -1
    if (x > y) return 1
    return 0
  })
  return sortedParkingLots
}

export const EmptyComponent = () => {
  const classes = ShowAppListStyles()
  return (
    <div className={classes.noMatchesContainer}>
      <Text className={classes.noMatches}>No Matches Available</Text>
    </div>
  )
}

export const ShowAppListStyles = makeStyles((theme) =>
  createStyles({
    noMatchesContainer: {
      display: 'flex',
      justifyContent: 'center',
      marginTop: 32,
    },
    noMatches: {
      color: theme.palette.primary.headerText,
      fontSize: 20,
      fontWeight: '600',
      display: 'flex',
      justifyContent: 'center',
      marginTop: 32,
    },
  }),
)

/* eslint-disable no-bitwise */
export function decode(encoded) {
  // array that holds the points
  // this function will decode the encoded segments for each point,
  // it will return a latitude and longitude pair to create the polylines on the MyMap component.
  const points = []
  let index = 0
  const len = encoded.length
  let lat = 0
  let lng = 0
  while (index < len) {
    let b
    let shift = 0
    let result = 0
    do {
      b = encoded.charAt(index++).charCodeAt(0) - 63 // finds ascii                                                                                    //and substract it by 63
      result |= (b & 0x1f) << shift
      shift += 5
    } while (b >= 0x20)

    const dlat = (result & 1) != 0 ? ~(result >> 1) : result >> 1
    lat += dlat
    shift = 0
    result = 0
    do {
      b = encoded.charAt(index++).charCodeAt(0) - 63
      result |= (b & 0x1f) << shift
      shift += 5
    } while (b >= 0x20)
    const dlng = (result & 1) != 0 ? ~(result >> 1) : result >> 1
    lng += dlng

    points.push({ lat: lat / 1e5, lng: lng / 1e5 })
  }
  return points
}

export function filterByValue(items, key, value) {
  const lowerCaseValue = value.toLowerCase()
  return items.filter((item) =>
    item[key].toLowerCase().includes(lowerCaseValue),
  )
}

export const mapLightStyles = [
  {
    featureType: 'landscape.man_made',
    elementType: 'geometry',
    stylers: [{ color: '#faf6eb' }],
  },
  {
    featureType: 'landscape.natural',
    elementType: 'geometry',
    stylers: [{ color: '#d0e3b4' }],
  },
  {
    featureType: 'landscape.natural.terrain',
    elementType: 'geometry',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'poi',
    elementType: 'labels',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'poi.business',
    elementType: 'geometry',
    stylers: [{ color: '#d0e3b4' }],
  },
  {
    featureType: 'poi.medical',
    elementType: 'geometry',
    stylers: [{ color: '#f4e6e9' }],
  },
  {
    featureType: 'poi.park',
    elementType: 'geometry',
    stylers: [{ color: '#c0d79d' }, { weight: 0.5 }],
  },
  {
    featureType: 'poi.school',
    elementType: 'geometry',
    stylers: [{ color: '#f7f1df' }],
  },
  {
    featureType: 'poi.sports_complex',
    elementType: 'geometry',
    stylers: [{ color: '#abc18b' }],
  },
  {
    featureType: 'road',
    elementType: 'geometry.stroke',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'road',
    elementType: 'labels',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'road.arterial',
    elementType: 'geometry.fill',
    stylers: [{ color: '#ffffff' }],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.fill',
    stylers: [{ color: '#ffe15f' }],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.stroke',
    stylers: [{ color: '#efd151' }],
  },
  {
    featureType: 'road.local',
    elementType: 'labels',
    stylers: [{ visibility: 'simplified' }],
  },
  {
    featureType: 'road.local',
    elementType: 'labels.text',
    stylers: [{ color: '#9e9e9e' }],
  },
  { featureType: 'transit', stylers: [{ visibility: 'simplified' }] },
  {
    featureType: 'transit.line',
    elementType: 'geometry',
    stylers: [{ weight: 0.5 }],
  },
  {
    featureType: 'transit.station.airport',
    elementType: 'geometry.fill',
    stylers: [{ color: '#cfb2db' }],
  },
  {
    featureType: 'transit.station.rail',
    stylers: [{ visibility: 'simplified' }],
  },
  {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [{ color: '#92e1e2' }, { visibility: 'simplified' }],
  },
]

export const mapDarkStyles = [
  { elementType: 'geometry', stylers: [{ color: '#242f3e' }] },
  { elementType: 'labels.text.fill', stylers: [{ color: '#746855' }] },
  { elementType: 'labels.text.stroke', stylers: [{ color: '#242f3e' }] },
  {
    featureType: 'administrative.land_parcel',
    elementType: 'labels',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'administrative.locality',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#d59563' }],
  },
  {
    featureType: 'poi',
    elementType: 'labels.text',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'poi',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#d59563' }],
  },
  { featureType: 'poi.business', stylers: [{ visibility: 'off' }] },
  {
    featureType: 'poi.park',
    elementType: 'geometry',
    stylers: [{ color: '#263c3f' }],
  },
  {
    featureType: 'poi.park',
    elementType: 'labels.text',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'poi.park',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#6b9a76' }],
  },
  {
    featureType: 'road',
    elementType: 'geometry',
    stylers: [{ color: '#38414e' }],
  },
  {
    featureType: 'road',
    elementType: 'geometry.stroke',
    stylers: [{ color: '#212a37' }],
  },
  {
    featureType: 'road',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#9ca5b3' }],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry',
    stylers: [{ color: '#746855' }],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.stroke',
    stylers: [{ color: '#1f2835' }],
  },
  {
    featureType: 'road.highway',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#f3d19c' }],
  },
  {
    featureType: 'road.local',
    elementType: 'labels',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'transit',
    elementType: 'geometry',
    stylers: [{ color: '#2f3948' }],
  },
  {
    featureType: 'transit.station',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#d59563' }],
  },
  {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [{ color: '#17263c' }],
  },
  {
    featureType: 'water',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#515c6d' }],
  },
  {
    featureType: 'water',
    elementType: 'labels.text.stroke',
    stylers: [{ color: '#17263c' }],
  },
]

export const formatArrivals = (arrivals) => {
  const currentTime = new Date()
  const arrivalTimes = arrivals.map((arrival) => {
    const nowTime = currentTime.getTime()
    let arrivalTime = new Date(arrival.arrival_at)
    arrivalTime = arrivalTime.getTime()
    let timeDiff
    if (arrivalTime < nowTime) {
      timeDiff = nowTime - arrivalTime
    } else {
      timeDiff = arrivalTime - nowTime
    }
    const minutes = Math.floor(timeDiff / 60000)
    return {
      ...arrival,
      time: minutes > 1 ? `${minutes} mins` : ' < 1 min',
    }
  })
  return arrivalTimes
}

export function setPolylineStyle({
  feature,
  parkingLotData,
  filterBy = [],
  additionalFilters = [],
  activeLotId,
  userParkingPermitData,
  darkMode,
}) {
  const datasetFeature = feature

  // Find the matching lot
  const lot = parkingLotData?.find(
    (lotItem) => lotItem.mapId === datasetFeature.datasetAttributes?.Parking_ID,
  )

  if (lot?.active !== true) {
    return { strokeOpacity: 0, fillOpacity: 0 }
  }

  if (activeLotId !== lot?.mapId) {
    // --- Apply filtering by employee or student
    if (Array.isArray(filterBy) && filterBy.length > 0) {
      const matchesFilter = filterBy.some((filter) => {
        if (filter === 'Faculty/Staff') return lot?.employee === true
        if (filter === 'student') return lot?.student === true
        if (filter === 'permit') {
          return userParkingPermitData?.garageIdInfo?.some(
            (permitLot) => permitLot.garageId === lot?.baseId,
          )
        }
        return false
      })
      if (!matchesFilter && activeLotId !== lot?.mapId) {
        return { strokeOpacity: 0, fillOpacity: 0 }
      }
    }
    // --- Filter by additional fields
    if (Array.isArray(additionalFilters) && additionalFilters.length > 0) {
      const matchesFilter = additionalFilters.every((filter) => {
        if (filter === 'visitor') return lot?.visitor > 0
        if (filter === 'handicapped') return lot?.handicapped > 0
        if (filter === 'evCharging') return lot?.evCharging !== 0
        if (filter === 'covered')
          return lot?.solar === true || lot?.garage === true
        if (filter === 'gated') return lot?.regularGate === true
        if (filter === 'permit') {
          return userParkingPermitData?.garageIdInfo?.some(
            (permitLot) => permitLot.garageId === lot?.baseId,
          )
        }
        return false
      })
      if (!matchesFilter) {
        return { strokeOpacity: 0, fillOpacity: 0 }
      }
    }
  }
  // --- Active style check ---
  const isActive =
    activeLotId && datasetFeature.datasetAttributes?.Parking_ID === activeLotId

  return {
    strokeColor: isActive ? '#7DBFD6' : '#007FAC',
    strokeOpacity: 1.0,
    strokeWeight: 3.0,
    fillColor: isActive ? '#007FAC' : '#7DBFD6',
    fillOpacity: isActive !== darkMode ? 1 : 0.5,
  }
}

export function removePolylineStyle(params) {
  const datasetFeature = params.feature
  const furColors =
    datasetFeature.datasetAttributes.CombinationofPrimaryandHighlightColor

  switch (furColors) {
    default:
      return {
        strokeColor: 'transparent',
        strokeOpacity: 1.0,
        strokeWeight: 3.0,
        fillColor: 'transparent',
        fillOpacity: 0.5,
      }
  }
}

export function scheduleToHumanReadable(permitObj) {
  // 1. Create a copy of the object to ensure immutability
  const event = { ...permitObj }

  const ruleString = event?.eventRecurrences

  if (!ruleString) {
    return event
  }

  // 1. Define day abbreviations and their full names in order
  const DAY_MAP = {
    SU: 'Sunday',
    MO: 'Monday',
    TU: 'Tuesday',
    WE: 'Wednesday',
    TH: 'Thursday',
    FR: 'Friday',
    SA: 'Saturday',
  }
  const ORDERED_DAYS = ['SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA']

  // 2. Extract RRULE parts
  const rruleParts = {}
  // Regex to find all key=value pairs
  const parts = ruleString.matchAll(/(\w+)=([^;]+)/g)
  // eslint-disable-next-line
  for (const match of parts) {
    // eslint-disable-next-line
    rruleParts[match[1]] = match[2]
  }

  let humanReadableRecurrence = ''

  // Check for FREQ=WEEKLY
  if (rruleParts.FREQ !== 'WEEKLY') {
    humanReadableRecurrence = 'Custom or non-weekly recurrence'
  } else {
    // Logic for weekly recurrence (Steps 3, 4, 5)

    const bydayValue = rruleParts.BYDAY

    if (!bydayValue) {
      humanReadableRecurrence = '**Every Day**'
    } else {
      const specifiedDaysAbbr = new Set(bydayValue.split(','))
      const scheduledDays = ORDERED_DAYS.filter((day) =>
        specifiedDaysAbbr.has(day),
      )

      if (scheduledDays.length === 0) {
        humanReadableRecurrence = 'No specific days set'
      } else {
        // 4. Check for common patterns
        // eslint-disable-next-line
        if (scheduledDays.length === 7) {
          humanReadableRecurrence = '**Every Day**'
        } else {
          const WEEKDAYS = new Set(['MO', 'TU', 'WE', 'TH', 'FR'])
          const isWeekdays =
            [...specifiedDaysAbbr].every((day) => WEEKDAYS.has(day)) &&
            specifiedDaysAbbr.size === WEEKDAYS.size
          if (isWeekdays) {
            humanReadableRecurrence = '**Monday through Friday**'
          } else {
            const WEEKENDS = new Set(['SA', 'SU'])
            const isWeekends =
              [...specifiedDaysAbbr].every((day) => WEEKENDS.has(day)) &&
              specifiedDaysAbbr.size === WEEKENDS.size
            if (isWeekends) {
              humanReadableRecurrence = '**Saturday through Sunday**'
            } else {
              // 5. General contiguous or non-contiguous list
              const fullDayNames = scheduledDays.map((abbr) => DAY_MAP[abbr])

              if (scheduledDays.length > 2) {
                const startIndex = ORDERED_DAYS.indexOf(scheduledDays[0])
                const endIndex = ORDERED_DAYS.indexOf(
                  scheduledDays[scheduledDays.length - 1],
                )

                const contiguousBlock = ORDERED_DAYS.slice(
                  startIndex,
                  endIndex + 1,
                )
                const isContiguous =
                  scheduledDays.every((day, i) => day === contiguousBlock[i]) &&
                  scheduledDays.length === contiguousBlock.length

                if (isContiguous) {
                  const startDay = DAY_MAP[scheduledDays[0]]
                  const endDay =
                    DAY_MAP[scheduledDays[scheduledDays.length - 1]]
                  humanReadableRecurrence = `**${startDay} through ${endDay}**`
                }
              }

              // If no match yet, use the list format
              if (!humanReadableRecurrence) {
                if (fullDayNames.length === 1) {
                  humanReadableRecurrence = `**Every ${fullDayNames[0]}**`
                } else if (fullDayNames.length === 2) {
                  humanReadableRecurrence = `**${fullDayNames[0]} and ${fullDayNames[1]}**`
                } else {
                  const daysStr = fullDayNames.slice(0, -1).join(', ')
                  humanReadableRecurrence = `**${daysStr}, and ${
                    fullDayNames[fullDayNames.length - 1]
                  }**`
                }
              }
            }
          }
        }
      }
    }
  }

  // 2. Assign the final human-readable string to the copied object
  //    This replaces the original ruleString value.
  event.eventRecurrences = humanReadableRecurrence
  // 3. Return the new, modified object
  return event.eventRecurrences
}

export function formatTimeString(timeString) {
  const date = new Date(`1970-01-01T${timeString}Z`)
  const readableTime = date.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
    timeZone: 'UTC', // Ensures the time remains exactly 06:00
  })
  return readableTime
}
